module.exports = __webpack_public_path__ + "assets/img/downBtn.a5ed8a38.png";